import { request } from "./request";

const BASE_URL = "/api/email_unsubscriptions";

export default {
  async fetch() {
    return await request({ url: BASE_URL, method: "GET" });
  },

  async update(groupIds) {
    return await request({
      url: BASE_URL,
      method: "PUT",
      data: { group_ids: groupIds },
    });
  },

  async unsubscribe(groupId) {
    return await request({
      url: `${BASE_URL}/unsubscribe/${encodeURIComponent(groupId)}`,
      method: "PUT",
    });
  },
};
